import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesRoutes } from './pages.routing';

import { JwtLoginComponent } from './login/jwt-login.component';

@NgModule({
  imports: [CommonModule, RouterModule.forChild(PagesRoutes), FormsModule, ReactiveFormsModule, NgbTooltipModule],
  declarations: [JwtLoginComponent],
})
export class PagesModule {}
